import { DefaultAbilityAction } from '@core/shared/ability';
import { ACCESS_SERVICE_PLUGIN_TOKEN } from '@core/shared/access';
import { BaseFeature, FeatureType } from '@core/shared/feature';
export class UsersBaseFeature extends BaseFeature {
  static {
    this.featureInfo = {
      context: {"package":"@common/users/feature","featureId":"common-users"},
      bundledItemModels: ["UserItem", "UserStateHistoryItem", "UserActivityHistoryItem", "ReferrerItem", "CompanyItem", "CompanyDemoItem", "CompanyAddressItem"],
      // list is auto-generated by generate-model-ids
      abilityActions: [{
        action: DefaultAbilityAction.View,
        defaultBias: -1
      }, {
        action: 'Company.View',
        defaultBias: -1
      }, {
        action: 'Company.Manage',
        defaultBias: -1
      }, {
        action: 'IsCompanyManager',
        defaultBias: -1,
        programmatic: true
      }, {
        action: 'IsCompanyMember',
        defaultBias: -1,
        programmatic: true
      }],
      plugins: [{
        forPlatform: 'frontend',
        type: FeatureType.Permanent,
        pluginClassName: 'UsersFrontendFeature'
      }, {
        forPlatform: 'frontend-management',
        type: FeatureType.Dynamic,
        pluginClassName: 'UsersFrontendManagementFeature',
        simpleAbilityCheck: 'Feature.common-users.Company.Manage'
      }, {
        forPlatform: 'admin',
        type: FeatureType.Permanent,
        pluginClassName: 'UsersAdminFeature'
      }, {
        forPlatform: 'backend',
        type: FeatureType.Permanent,
        pluginClassName: 'UsersBackendFeature',
        moduleFactory: 'forRoot'
      }, {
        forPlatform: 'backend-admin',
        type: FeatureType.Permanent,
        pluginClassName: 'UsersBackendAdminFeature',
        moduleFactory: 'forRoot'
      }],
      providers: [{
        forPlatform: 'frontend',
        token: ACCESS_SERVICE_PLUGIN_TOKEN,
        providerName: 'AccessUserPluginFrontend',
        importFrom: 'frontend-shared'
      }, {
        forPlatform: 'admin',
        token: ACCESS_SERVICE_PLUGIN_TOKEN,
        providerName: 'AccessUserPluginFrontend',
        importFrom: 'frontend-shared'
      }, {
        forPlatform: 'backend',
        token: ACCESS_SERVICE_PLUGIN_TOKEN,
        providerName: 'AccessUserBackendPlugin',
        importFrom: 'backend-shared'
      }]
    };
  }
  getSharedDefinition() {
    const frontendRouterLinkResolvers = {
      'login': () => '/user/login',
      // still valid, wraps available auth strategies
      'logout': () => '/user/logout',
      'profile': () => '/user/profile',
      'registration': (data = {}) => {
        const params = [];
        if (data.referrerCode) params.push('referrerCode=' + data.referrerCode /*URL_PARAM_REFERRER_CODE*/);
        return '/user/registration' + (params.length > 0 ? '?' + params.join('&') : '');
      },
      'management-users': subroute => '/management/users' + (subroute ? '/' + subroute : '')
    };
    const adminRouterLinkResolvers = {
      'login': () => '/user/login',
      'logout': () => '/user/logout',
      'profile': () => '/user/profile',
      'users': () => 'users/all',
      'user': info => 'users/all/' + (typeof info === 'number' ? info : info.id)
    };
    if (this.config.get('users.enableCompanies', false)) {
      adminRouterLinkResolvers['companies'] = () => 'users/companies';
      adminRouterLinkResolvers['company'] = info => 'users/companies/' + (typeof info === 'number' ? info : info.id);
    }
    return {
      routerLinkResolvers: {
        frontend: frontendRouterLinkResolvers,
        admin: adminRouterLinkResolvers
      }
    };
  }
}